import React from "react";
import "./CSS/CardSection.css";

import img1 from "./IMAGES/DSC09356-Enhanced-NR.JPG.jpg";
import img2 from "./IMAGES/Psychology in Interior Design.jpg";
import img3 from "./IMAGES/Timeless Furniture Pieces Every Home Needs (2).jpg";

const cardData = [
  {
    image: img1,
    date: "February 5, 2025",
    title: "Effortless Styling",
    desc: "Elevate your look with timeless draping styles and modern elegance.",
  },
  {
    image: img2,
    date: "January 21, 2026",
    title: "Our Muse",
    desc: "Celebrating you  the inspiration behind every design we create.",
  },
  {
    image: img3,
    date: "February 22, 2025",
    title: "Latest Creations",
    desc: "Experience newly crafted sarees that blend heritage with refined design.",
  },
];

const CardsSection = () => {
  return (
    <div className="about-cards-section">
      {cardData.map((card, index) => (
        <div className="about-card" key={index}>
          <img src={card.image} alt={card.title} />

          <div className="about-card-content">
            <p className="about-date">• {card.date}</p>
            <h3>{card.title}</h3>
            <p className="about-desc">{card.desc}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardsSection;
